import React, { useState, useEffect, useRef } from "react";

import { API_URL } from "./helpers";

import "./styles.css";

import Alert from "./components/Alert";
import Input from "./components/Input";
import Textarea from "./components/Textarea";
import InputFile from "./components/InputFile";
import Checkbox from "./components/Checkbox";
import Msg from "./components/Msg";
import Submit from "./components/Submit";

import Terms from "./Terms";

export default function SubmitForm({ setStatus }) {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		agree: false,
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		init();
	});

	const init = async (id) => {
		const url = new URL(`${API_URL}/submitInit`);

		try {
			const response = await fetch(url.href, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setAlert({});
			} else {
				setAlert({ type: "error", text: json.text });
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "agree") {
			let newChecked = !names[name];
			setNames((names) => ({ ...names, [name]: newChecked }));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/submit`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "agree") {
				formData.append(key, names[key] ? "1" : "0");
			} else {
				formData.append(key, value);
			}
		});

		try {
			const response = await fetch(url.href, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setStatus(1);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="invite-container" style={{ marginBottom: "10px" }}>
						<div>
							<p>
								For generations, the Valero Texas Open has been more than a golf
								tournament. It’s where families gather, friendships are made,
								stars are born, legends are celebrated, traditions are passed
								down, and memories are created. Whether you’re a fan, volunteer,
								sponsor, player, military member, charity partner, first-time or
								long-time attendee, you’ve helped make the Valero Texas Open
								part of the fabric of our community.
							</p>

							<p>
								As we embark the 105th anniversary of the Valero Texas Open, we
								want to hear your story. What brings you back year after year?
								What is that moment at the tournament that impacted your life,
								strengthened a relationship, made you laugh, got your heart rate
								up, inspired you and created a lasting memory?
							</p>

							<p>
								As we look toward the future, we want to capture the stories
								that have made the Valero Texas Open what it is today. Big
								moments. Small moments. Funny moments. Meaningful moments.
								Whether your story happened this year or 30+ years ago, we’d
								love to hear it.
							</p>

							<p>
								Together, these stories will help preserve the legacy of the
								Valero Texas Open and celebrate its impact on our community.
								Share your story, photos, or videos for a chance to be featured
								in future Valero Texas Open marketing and social media campaigns
								as we celebrate the people who make this tournament so much more
								than a golf tournament.{" "}
								<b>
									The Valero Texas Open is Our Tournament. Tell Us Why It’s
									Yours.
								</b>
							</p>

							<p>
								<b>
									While we welcome your stories at any time throughout the year,
									please submit yours by October 31, 2026 to be considered for
									the 2027 Valero Texas Open marketing and social media
									campaign.
								</b>
							</p>

							<table
								className="approved rsvp"
								style={{ marginTop: "25px", marginBottom: "15px" }}
							>
								<thead>
									<tr>
										<th style={{ fontSize: "125%" }}>Example Stories</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="left" style={{ paddingLeft: "15px" }}>
											<p style={{ marginTop: "7.5px", fontSize: "110%" }}>
												For generations the Valero Texas Open has created
												memories for thousands of our fans and supporters. We
												want to know your story.
											</p>

											<ul style={{ marginBottom: "0" }}>
												<li>
													A father introducing his child to golf and starts a
													tradition of attending the tournament.
												</li>
												<li>
													A marriage proposal while at the Valero Texas Open
												</li>
												<li>A volunteer making lifelong friends.</li>
												<li>
													A family positively impacted by the charitable
													contributions of the Valero Texas Open
												</li>
												<li>
													A military veteran enjoying the Heroes Pavilion as an
													escape from daily challenges.
												</li>
												<li>
													A fan witnessing an unforgettable moment on the golf
													course.
												</li>
												<li>
													An interaction with a PGA TOUR player that made a
													lasting impression.
												</li>
											</ul>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<img
							src={`${API_URL}/assets/right.jpg`}
							alt="VTO Fun"
							style={{ width: "450px" }}
						/>
					</div>

					<form
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
						className="well"
						style={{ marginTop: "25px" }}
					>
						<h3 style={{ marginTop: "0", marginBottom: "0" }}>
							Story Submit Form
						</h3>

						<p style={{ marginTop: "10px", marginBottom: "15px" }}>
							Now it’s your turn to tell the story. Share your Valero Texas Open
							memory and help us celebrate the people, traditions, and
							experiences that make this tournament part of the heart of our
							community.
						</p>

						<div className="form-group">
							<Input
								name="fname"
								label="First Name"
								reqd={true}
								value={""}
								update={handleUpdate}
								errors={errors}
								autocomplete="given-name"
							/>

							<Input
								name="lname"
								label="Last Name"
								reqd={true}
								value={""}
								update={handleUpdate}
								errors={errors}
								autocomplete="family-name"
							/>
						</div>

						<div className="form-group">
							<Input
								name="email"
								label="Email Address"
								reqd={true}
								value={""}
								update={handleUpdate}
								errors={errors}
							/>

							<Input
								name="phone"
								label="Phone"
								reqd={true}
								value={""}
								update={handleUpdate}
								errors={errors}
								autocomplete="tel"
							/>
						</div>

						<h4
							style={{
								marginTop: "0",
								lineHeight: "22px",
								marginBottom: "10px",
								fontSize: "1.1rem",
							}}
						>
							Your Story
						</h4>

						<div className="form-group one">
							<Textarea
								name="comments"
								label={`Please share with us your story or memory from the VTO`}
								reqd={true}
								value={names.comments || ""}
								update={handleUpdate}
								errors={errors}
								taller={true}
							/>
						</div>

						<h4
							style={{
								marginTop: "0",
								lineHeight: "22px",
								marginBottom: "10px",
								fontSize: "1.1rem",
							}}
						>
							Optional Photos & Videos
						</h4>

						<div className="form-group one" style={{ marginBottom: "0" }}>
							<InputFile
								name="file"
								label="Select a file to include with your story"
								reqd={false}
								value={""}
								update={handleUpdate}
								errors={errors}
							/>
						</div>

						<p>
							Optional: Upload desired content to help tell your story. All ages
							welcome to participate.
						</p>

						<Terms />

						<div
							className="form-group checkbox"
							style={{ marginTop: "10px", marginBottom: "7.5px" }}
						>
							<Checkbox
								label={`I have read and agree to the Submission Release above.`}
								name="agree"
								checked={names.agree || false}
								click={handleUpdate}
							/>
						</div>

						<div className="msg-submit">
							{msg.type && <Msg data={msg} />}

							<div
								className={
									msg.type === "working" || msg.type === "success"
										? "hidden"
										: "submit-container"
								}
							>
								<Submit path="" left="" submit="Submit Story" />
							</div>
						</div>
					</form>
				</>
			)}
		</>
	);
}
